<template>
  <div class="day-selector-v5">
    <div class="day-selector-v5__title">
      Сколько дней будете питаться
    </div>
    <div class="day-selector-v5__info">
      <Image
        class="day-selector-v5__info-img"
        :src="'@/assets/images/newOrder/info-icon.svg'"
      />
      <div class="day-selector-v5__info-text">
        Даём скидку на первый заказ
      </div>
    </div>

    <swiper
      v-if="getDays.length > 0"
      ref="menuSlider"
      slides-per-view="auto"
      :space-between="8"
      :centered-slides="true"
      :update-on-window-resize="false"
      :centered-slides-bounds="true"
      class="day-selector-v5__swiper"
      :class="swiperClass"
      @swiper="setSwiper"
    >
      <swiper-slide
        v-for="(item, index) in getDays"
        :key="'day-selector' + index"
        class="day-selector-v5__slide"
      >
        <DayOption
          :is-active="index === activeIndex"
          @click="setActive(index)"
        >
          <template #name>
            {{ item.name }} дн
          </template>
          <template
            v-if="item.discount"
            #discount
          >
            <span v-html="item.discount" />
          </template>
        </DayOption>
      </swiper-slide>
    </swiper>
    <swiper
      v-else
      ref="menuSlider"
      slides-per-view="auto"
      :space-between="8"
      :centered-slides="true"
      :centered-slides-bounds="true"
      class="day-selector-v5__swiper"
      @swiper="setSwiper"
    >
      <swiper-slide
        v-for="item in 3"
        :key="'day-selector' + item"
        class="day-selector-v5__slide"
      >
        <DayOption class="_skeleton">
          <template #name>
            <span
              class="skeleton-box radius skeleton__selector-content"
            />
          </template>
        </DayOption>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import DayOption from './DayOption.vue'
import { Swiper, SwiperSlide } from 'swiper/swiper-vue'

export default {
  name: 'DaysSelectorV5',
  components: {
    Swiper,
    SwiperSlide,
    DayOption,
  },
  props: {
    days: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: null,
    },
  },
  emits: ['update:value'],
  data () {
    return {
      mySwiper: null,
    }
  },
  computed: {
    swiperClass () {
      return {
        'day-selector-v5__swiper--length-1': this.getDays.length === 1,
        'day-selector-v5__swiper--length-2': this.getDays.length === 2,
      }
    },
    getDays () {
      const days = []

      this.days.forEach(item => {
        const discountPercent = item?.promoInfo?.discounts.find(
          value => value.discountType === 'percent',
        )
        const discountAbsolute = item?.promoInfo?.discounts.find(
          value => value.discountType === 'absolute',
        )
        const mealDaysGift = item?.promoInfo?.discounts.find(
          value => value.discountType === 'mealdays',
        )

        let discount = null

        if (discountPercent) {
          discount = `-${discountPercent.discountValue}%`
        }

        if (discountAbsolute) {
          discount = `-${discountAbsolute?.discountValue}₽`
        }

        if (mealDaysGift) {
          discount = `+${this.$numberLingFormWithNumberFunc(mealDaysGift?.discountValue, 'день', 'дня', 'дней')}
          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_25_17012)">
            <path d="M3.01967 0.643324C2.38967 0.639991 1.77634 1.24666 2.05634 1.99999H0.999674C0.822863 1.99999 0.653294 2.07023 0.52827 2.19525C0.403246 2.32028 0.333008 2.48985 0.333008 2.66666V3.33332C0.333008 3.42173 0.368127 3.50651 0.430639 3.56903C0.493151 3.63154 0.577936 3.66666 0.666341 3.66666H3.66634V2.66666H4.33301V3.66666H7.33301C7.42141 3.66666 7.5062 3.63154 7.56871 3.56903C7.63122 3.50651 7.66634 3.42173 7.66634 3.33332V2.66666C7.66634 2.48985 7.5961 2.32028 7.47108 2.19525C7.34606 2.07023 7.17649 1.99999 6.99967 1.99999H5.94301C6.33301 0.909991 4.86634 0.139991 4.18967 1.07999L3.99967 1.33332L3.80967 1.07332C3.59967 0.776658 3.30967 0.646658 3.01967 0.643324ZM2.99967 1.33332C3.29634 1.33332 3.44634 1.69332 3.23634 1.90332C3.02634 2.11332 2.66634 1.96332 2.66634 1.66666C2.66634 1.57825 2.70146 1.49347 2.76397 1.43096C2.82648 1.36844 2.91127 1.33332 2.99967 1.33332ZM4.99967 1.33332C5.29634 1.33332 5.44634 1.69332 5.23634 1.90332C5.02634 2.11332 4.66634 1.96332 4.66634 1.66666C4.66634 1.57825 4.70146 1.49347 4.76397 1.43096C4.82648 1.36844 4.91127 1.33332 4.99967 1.33332ZM0.666341 3.99999V6.66666C0.666341 6.84347 0.736579 7.01304 0.861603 7.13806C0.986628 7.26309 1.1562 7.33332 1.33301 7.33332H6.66634C6.84315 7.33332 7.01272 7.26309 7.13775 7.13806C7.26277 7.01304 7.33301 6.84347 7.33301 6.66666V3.99999H4.33301V6.66666H3.66634V3.99999H0.666341Z" fill="white"/>
            </g>
            <defs>
            <clipPath id="clip0_25_17012">
            <rect width="8" height="8" fill="white"/>
            </clipPath>
            </defs>
          </svg>
          `
        }
        let name = item.numberOfMealDays
        if (item.subscriptionId_H) {
          name = item.subscriptionDays
        }

        days.push({
          name: name,
          discount: discount,
        })
      })

      return days
    },

    activeIndex () {
      if (!this.value) {
        return 0
      }
      return this.days.findIndex(item => {
        if (this.value.subscriptionId_H) {
          return this.value.subscriptionId_H === item.subscriptionId_H
        } else {
          return this.value.numberOfMealDays === item.numberOfMealDays
        }
      })
    },
  },
  methods: {
    setSwiper (swiper) {
      this.mySwiper = swiper
    },
    setActive (index) {
      if (this.mySwiper) {
        this.mySwiper.slideTo(index, 300)
      }
      this.$emit('update:value', this.days[index])
    },
  },
}
</script>

<style lang="scss">
$prefix: 'day-selector-v5';

.#{$prefix} {
  width: 100%;
  padding: 0.02rem 0.16rem;
  margin-bottom: .12rem;
  overflow: hidden;
  &__title {
    margin-bottom: .16rem;
    color: var(--main-black, #0D0D0D);
    font-size: 0.2rem;
    font-style: normal;
    font-weight: 600;
    line-height: 0.24rem; /* 120% */
  }
  &__info {
    display: flex;
    align-items: center;
    padding: 0.1rem 0.16rem;
    margin-bottom: 0.11rem;
    border-radius: 0.14rem;
    background: var(--greyscale-grey-4, #F5F5F5);
    color: var(--greyscale-grey-60, #666);
    font-size: 0.12rem;
    font-style: normal;
    font-weight: 400;
    line-height: 0.16rem; /* 133.333% */
    letter-spacing: 0.001rem;
    &-img {
      width: 0.24rem;
      height: 0.24rem;
      margin-right: 0.15rem;
    }
  }
  &__swiper {
    overflow: visible !important;
    padding-top: 0.04rem !important;
    padding-bottom: 0.01rem !important;
    &--length {
      &-1 {
        .#{$prefix} {
          &__slide {
            min-width: 100%;
          }
        }
      }
      &-2 {
        .#{$prefix} {
          &__slide {
            min-width: calc(50% - 4px);
          }
        }
      }
    }
  }
  &__slide {
    width: .72rem !important;
    white-space: nowrap;
    min-width: fit-content;
  }
}
</style>
